import React from 'react';
import { Link } from 'react-router';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ToastContainer, toast } from 'react-toastify';
import * as appointmentActions from '../../actions/appointmentActions';
import 'react-toastify/dist/ReactToastify.css';
import {
	Modal,

} from 'react-bootstrap';
import classNames from 'classnames';
import * as constant from '../../constants/constant';
import validator from '../common/validator';
const autoBind = require('auto-bind');
import StarRatingComponent from 'react-star-rating-component';
import { browserHistory } from 'react-router';
import _ from 'underscore';

const style = {
	// textAlign: 'center',
	fontWeight: 600,
	fontSize: 14
}
class RatingDisclamer extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			modalOpen: true,
			firstTimeLoad: true,
			defualtRate: constant.DEFAULT_RATING_STARS,
			ratingQuestions: [],
			feedback: { value: '', message: '', isValid: true },
			ratingRemainder: { value: '', message: '', isValid: true },
			spinner: false,
			errorFlag: ''
		};
		this.onStarClick = this.onStarClick.bind(this);
		this.onChange = this.onChange.bind(this);
		this.setQuestionId = this.setQuestionId.bind(this);
		this.submitFeedback = this.submitFeedback.bind(this);

	}

	submitFeedback(event) {

		event.preventDefault();
		this.setState({ spinner: true });
		var ratingRecord = [];
		var state = this.state;
		for (var i = 0; i < state.ratingQuestions.length; i++) {
			ratingRecord.push(state["rate" + i]);
		}

		var arrRate = _.pluck(ratingRecord, 'value');

		if (_.without(arrRate, 0).length > 0 || (this.state.feedback.value && this.state.feedback.value != '')) {
			var obj = {
				doctorId: this.props.doctorId,
				patientId: localStorage.getItem('userId'),
				appointmentId: this.props.appointmentId,
				feedback: this.state.feedback.value,
				ratingRemainder: this.state.ratingRemainder.value,
				ratingRecord: ratingRecord
			}
			this.props.actions.addRating(obj);
			this.props.closeModal();
		} else {
			this.setState({ errorFlag: 'Atleast add rating or your valuable feedback', spinner: false });
		}


	}
	setQuestionId(index, name) {
		var state = this.state;
		state[name].ratingQId = state.ratingQuestions[index]._id;
		this.setState(state);
	}
	onStarClick(nextValue, prevValue, name) {
		var state = this.state;
		state.firstTimeLoad = false;
		state[name] = { value: state.defualtRate, ratingQId: '' }
		state[name].value = nextValue;
		state.errorFlag = '';
		this.setState(state);
		var splitArr = name.split("rate");
		this.setQuestionId(splitArr[1], name);

	}
	onChange(event) {
		var state = this.state;
		state.firstTimeLoad = false;
		if (event.target.name == "ratingRemainder") {
			let flag = (event.target.value == 'false' || event.target.value == '');
			state[event.target.name].value = flag == true ? true : false;
			this.setState(state);
		} else {
			state[event.target.name].value = event.target.value;
			state.errorFlag = '';
			this.setState(state);
		}
	}
	componentWillReceiveProps(nextProps) {
		var state = this.state;
		state.ratingQuestions = nextProps.ratingQuestions;
		state.spinner = (nextProps.ratingSucess == false || nextProps.ratingSucess == true) ? nextProps.ratingSucess : state.spinner;
		this.setState(state);
		console.log("this.state feedback", this.state);
	}
	componentWillMount() {
		this.props.actions.getRatingQuestions();
	}
	componentDidUpdate(prevProps, prevState) {
		// for giving atleast 3 stars
		var state = this.state;
		if (state.firstTimeLoad) {
			for (var i = 0; i < state.ratingQuestions.length; i++) {
				state['rate' + i] = { value: constant.DEFAULT_RATING_STARS, ratingQId: state.ratingQuestions[i]._id }
			}
		}

	}
	render() {
		var ratingQuestions = this.state.ratingQuestions;
		return (
			<Modal show={this.props.modalOpen} size="modal-sm" onHide={this.props.closeDisclaimer}>
				<Modal.Header>
					{/* <ModalClose onClick={this.props.closeDisclaimer} /> */}
				</Modal.Header>
				<Modal.Body>
					<form className="signup-form" id="loginForm" >
						<div >
							<h4  className="feedbackBtn">Disclaimer</h4>
							<p >Your feedback should not identify or make reference to any individual, living or otherwise, in any way, whether in a positive or negative light.  You must also be objective in your feedback, with an emphasis on tangible actions recorded in your feedback post.  The aim of the feedback mechanism is to guide other prospective patients, any official or unofficial complaints should be followed up with Medfix Support Team.  All posts are moderated before being published and may be declined or withdrawn at any time.  Your use of the feedback system constitutes acceptance of the Medfix Terms and Conditions.</p>
						</div> 
					
					</form>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >
		);
	}
}
function mapStateToProps(state, ownProps) {
	return {
		ratingQuestions: state.appointment.ratingQuestions,
		ratingSucess: state.appointment.ratingSucess
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(RatingDisclamer);
